import React from "react";

import { Divider, SelectChangeEvent, Stack } from "@mui/material";

import SettingsTitle from "@app/analytics/account/components/SettingsTitle";
import { TOOLTIPS } from "@app/common/content";
import type {
  EnterpriseRole,
  EnterpriseWorkspaceSettings,
  EnterpriseWorkspaceSettingUpdateConfig,
  UpdateWorkspaceSettingsBody,
} from "@app/common/workspaces/types";

import WorkspaceEditRoleDropdown from "./WorkspaceEditRoleDropdown";
import WorkspaceViewRoleSlider from "./WorkspaceViewRoleSlider";

interface WorkspacePermissionItemProps {
  disabled: boolean;
  name: keyof EnterpriseWorkspaceSettings;
  onSettingUpdate: (settingsToUpdate: UpdateWorkspaceSettingsBody) => void;
  recommendation?: { value: string; description: string };
  setting: EnterpriseWorkspaceSettingUpdateConfig;
  subtitle: string;
  title: string;
  tooltip?: string;
}

const WorkspacePermissionItem = ({
  disabled,
  name,
  onSettingUpdate,
  recommendation,
  setting,
  subtitle,
  title,
  tooltip,
}: WorkspacePermissionItemProps) => {
  const handleUpdateViewSetting = (role: string) => {
    onSettingUpdate({
      [name]: {
        edit: role === "admin" ? "admin" : setting.edit,
        view: role as EnterpriseRole,
      },
    });
  };

  const handleUpdateEditSetting = (event: SelectChangeEvent) => {
    onSettingUpdate({
      [name]: { edit: event.target.value },
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ width: "100%" }}
    >
      <SettingsTitle
        title={title}
        subtitle={subtitle}
        recommendation={recommendation}
        tooltip={tooltip}
        sx={{ mr: 2 }}
      />
      <Stack direction="row" sx={{ flexShrink: 0 }}>
        <WorkspaceViewRoleSlider
          disabled={disabled}
          onChange={handleUpdateViewSetting}
          role={setting.view}
        />
        <Divider orientation="vertical" sx={{ height: "47px", mx: "32px" }} />
        <WorkspaceEditRoleDropdown
          name={name}
          disabled={disabled || setting.view === "admin"}
          onChange={handleUpdateEditSetting}
          selected={setting.edit}
          tooltip={disabled ? TOOLTIPS.upsell.upgradeToPro : undefined}
        />
      </Stack>
    </Stack>
  );
};

export default WorkspacePermissionItem;
